interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  const start = Math.max(1, Math.min(page - 2, totalPages - 4));
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i += 1) pages.push(i);

  const baseBtn =
    "flex h-9 min-w-9 items-center justify-center rounded-md px-3 text-sm font-medium transition-colors";

  return (
    <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" aria-label="分页">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className={`${baseBtn} border border-background-200/70 text-foreground-700 hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-left-s-line leading-none"></i>
      </button>

      {start > 1 && (
        <>
          <button type="button" onClick={() => onChange(1)} className={`${baseBtn} border border-background-200/70 text-foreground-700 hover:bg-background-100`}>
            1
          </button>
          {start > 2 && <span className="px-1 text-foreground-400">…</span>}
        </>
      )}

      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`${baseBtn} ${
            p === page
              ? "bg-primary-500 text-background-50"
              : "border border-background-200/70 text-foreground-700 hover:bg-background-100"
          }`}
        >
          {p}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="px-1 text-foreground-400">…</span>}
          <button type="button" onClick={() => onChange(totalPages)} className={`${baseBtn} border border-background-200/70 text-foreground-700 hover:bg-background-100`}>
            {totalPages}
          </button>
        </>
      )}

      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className={`${baseBtn} border border-background-200/70 text-foreground-700 hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <i className="ri-arrow-right-s-line leading-none"></i>
      </button>
    </nav>
  );
}